//import Example from './example';
import GoogleMapsApi from "./google-maps-api";
import GeoRetailerMap from "./geolocation-map";

document.addEventListener("DOMContentLoaded", function () {
    //google maps
    const gmapi = new GoogleMapsApi({});
    gmapi.init();

    if (document.querySelector("#geo-retailer-map")) {
        const grm = new GeoRetailerMap({});
        grm.init();
    }
});
